module.exports = __webpack_public_path__ + "static/media/sallie.ebe2683e.svg";